import { SelectionCategories } from '@revelio/iso-utility';

export const ROLE_GRANULARITY_FILTERS = [
  SelectionCategories.JOB_CATEGORY,
  SelectionCategories.ROLE_K150,
  SelectionCategories.ROLE_K1500,
];

export const GEOGRAPHY_GRANULARITY_FILTERS = [
  SelectionCategories.REGION,
  SelectionCategories.COUNTRY,
  SelectionCategories.METRO_AREA,
];

export const RICS_FILTERS = [
  SelectionCategories.RICS_K10,
  SelectionCategories.RICS_K400,
];
